const getFileExtension = (filename) => {
  const matches = filename.match(/^.*?(?:\.([^.]+))?$/);

  return matches.length === 2 ? matches[1] : "";
};

export default getFileExtension;
